// Транслитерация по той же схеме, что объясняется в уроке 0 (и что использует бэкенд в russian.py)
const TO_LATIN = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'jo', ж: 'zh', з: 'z', и: 'i', й: 'j', к: 'k', л: 'l',
  м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh',
  щ: 'shch', ъ: '—', ы: 'y', ь: '—', э: 'e', ю: 'ju', я: 'ja',
};
// для сплошного текста: мягкий знак — апостроф, твёрдый не пишем
const IN_TEXT = { ...TO_LATIN, ь: "'", ъ: '' };
const STRESS = '́';
const CYRILLIC = /[а-яё]/i;

export const hasCyrillic = (text) => CYRILLIC.test(text || '');

// «ма́ма» → [['м','m'], ['а́','a'], ['м','m'], ['а','a']] — ударение остаётся на букве, чтобы его было видно
export function lettersOf(word) {
  const out = [];
  for (const ch of word || '') {
    if (ch === STRESS && out.length) {
      out[out.length - 1][0] += ch;
      continue;
    }
    const latin = TO_LATIN[ch.toLowerCase()];
    if (latin) out.push([ch, latin]);
  }
  return out;
}

// «Я живу́ в Москве́» → «Ja zhivú v Moskvé»: регистр сохраняется, ударение переносится на латинскую гласную
export function toLatin(text) {
  let out = '';
  for (const ch of text || '') {
    if (ch === STRESS) {
      // ставим ударение на последнюю гласную уже написанного куска (я́ → já)
      const m = out.match(/[aeiouy](?=[^aeiouy]*$)/i);
      if (m) {
        const i = out.length - out.slice(m.index).length;
        out = out.slice(0, i + 1) + STRESS + out.slice(i + 1);
      }
      continue;
    }
    const lower = ch.toLowerCase();
    const latin = IN_TEXT[lower];
    if (latin === undefined) {
      out += ch;
    } else if (ch !== lower && latin) {
      out += latin[0].toUpperCase() + latin.slice(1);
    } else {
      out += latin;
    }
  }
  return out.normalize('NFC');
}
